import { rider } from '@/endpoints/rider';
import { shuttle } from '@/endpoints/mobile';
import Repository from './repository';

const client = new Repository();

export default {
  async getRequestsWithTracking(startDate, endDate, type) {
    const r = await client.get(rider.requestsWithTracking, {
      startDate,
      endDate,
      type,
    });
    return r;
  },
  async cancelRequest(requestId) {
    const r = await client.post(rider.cancelRequest.replace(':requestId', requestId));
    return r;
  },
  async cancelRecurringRequest(requestId) {
    const r = await client.post(rider.cancelRecurringRequest.replace(':requestId', requestId));
    return r;
  },
  async createNewRequest(payload) {
    const r = client.post(rider.requests, payload);
    return r;
  },
  async createNewRecurringRequest(payload) {
    const r = client.post(rider.recurringRequests, payload);
    return r;
  },
  async updateRequest(requestId, payload, type) {
    const url = rider.updateRequest.replace(':requestId', requestId);
    const params = type ? { ...payload, requestType: type } : payload;
    const r = client.post(url, params);
    return r;
  },
  async updateRecurringRequest(recurringId, payload, type) {
    const url = rider.updateRecurringRequest.replace(':recurringId', recurringId);
    const params = type ? { ...payload, requestType: type } : payload;
    const r = client.post(url, params);
    return r;
  },
  async approveOffer(offerId) {
    const url = rider.approveOffer.replace(':requestId', offerId);
    const r = client.post(url);
    return r;
  },
  async rejectOffer(offerId) {
    const url = rider.rejectOffer.replace(':requestId', offerId);
    const r = client.post(url);
    return r;
  },
  async getMyAddress() {
    const r = await client.get(rider.myAddress);
    return r;
  },
  async createAddress(payload) {
    const r = await client.post(rider.savedLocation, payload);
    return r;
  },
  async deleteAddress(id) {
    const r = await client.delete(rider.deleteLocation.replace(':savedLocationId', id));
    return r;
  },
  async editAddress(id, payload) {
    const r = await client.put(rider.editLocation.replace(':savedLocationId', id), payload);
    return r;
  },
  async editHomeAddress(payload) {
    const r = await client.post(rider.homeAddress, payload);
    return r;
  },
  async sendSms(payload) {
    const r = await client.post(rider.sendSms, payload);
    return r;
  },
  async verifyPhoneNumber(payload) {
    const r = await client.post(rider.verifyPhoneNumber, payload);
    return r;
  },

  // My Trips methods
  async getMyNextRides() {
    const r = await client.get(shuttle.myNextRides);
    return r;
  },
  async getDestinations() {
    const r = await client.get(shuttle.destinations);
    return r;
  },
  async getRouteDetails(routeId, reservationDay) {
    const url = shuttle.routeDetails.replace(':routeId', routeId);
    const r = await client.get(url, { reservationDay });
    return r;
  },
  async getVehicleLocation(workgroupInstanceId) {
    const r = await client.get(shuttle.vehicleLocation, { workgroupInstanceId });
    return r;
  },
  // Bulk vehicle positions for the search/map screen. `all` (from the
  // trackLoopVehiclesAllways company setting) also returns loop vehicles that
  // haven't gone active yet. Returns an array of { plate, latitude, longitude, ... }.
  async getVehiclePositions(plates, all) {
    const r = await client.post(shuttle.vehiclePositions, { plates, all });
    return r;
  },
  // Per-route station ETAs (HHmm ints). Returns { activeTrip, stations: [...] }.
  async getStationEtas(routeInstanceId) {
    const url = shuttle.stationEtas.replace(':routeInstanceId', routeInstanceId);
    const r = await client.get(url);
    return r;
  },
  async getActiveRideStatus(routeInstanceId, stationId) {
    const url = shuttle.activeRide.replace(':routeInstanceId', routeInstanceId).replace(':stationId', stationId);
    const r = await client.get(url);
    return r;
  },
  async createOrUpdateReservation(payload) {
    const r = await client.post(shuttle.reservations, payload);
    return r;
  },
  async cancelAllReservations(payload) {
    const r = await client.post(shuttle.cancelReservations, payload);
    return r;
  },
  async cancelDemand(payload) {
    const r = await client.post(shuttle.cancelDemand, payload);
    return r;
  },
  async optOut(workgroupInstanceId) {
    const r = await client.post(`${shuttle.optOut}?workgroupInstanceId=${workgroupInstanceId}`);
    return r;
  },
  async unsubscribe(routeId) {
    const r = await client.delete(`${shuttle.unsubscribe}/${routeId}`);
    return r;
  },
};
